import { Navigate, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user } = useAuth();
  const location = useLocation();
  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-obsidian px-4" data-testid="admin-login-page">
      <div className="grid-lines absolute inset-0" />
      <div className="panel relative z-10 w-full max-w-md p-8 sm:p-10">
        <Logo />
        <div className="mt-10 flex h-12 w-12 items-center justify-center rounded-xl border border-emerald-500/30 bg-emerald-500/10">
          <ShieldCheck className="h-6 w-6 text-emerald-400" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-semibold tracking-tight text-white">Admin panel</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">Restricted to the Meridian owner account. Sign in with the authorised Google account to continue.</p>
        {location.state?.error && (
          <p className="mt-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="admin-login-error">{location.state.error}</p>
        )}
        {user?.role === "client" && (
          <p className="mt-6 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-300">You're logged in as a client. Admin access requires the owner Google account.</p>
        )}
        <button onClick={signIn} className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition-[background-color,transform] duration-200 hover:bg-slate-200 active:scale-[0.98]" data-testid="admin-google-login-button">
          <svg className="h-4 w-4" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
          Continue with Google
        </button>
      </div>
    </div>
  );
}
